
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Αυτό προσφέρεται από το έργο
                    <a href="${0}">Folksonomy Engine</a>. Μην
                    διστάσετε να συμμετάσχετε ή να δώσετε σχόλια`,
'h5d824b4954e56ea5': html`Σαρώστε τα <span class="everyday">καθημερινά</span> <span class="foods">τρόφιμά σας</span>`,
'h6bdd1b427aa985a4': html`Αυτό το εργαλείο σάς επιτρέπει να διορθώσετε τη λίστα συστατικών. Μπορείτε να προσθέσετε, να αφαιρέσετε ή να επεξεργαστείτε τη λίστα συστατικών
                .
                <br>
                Αυτός ο χαρακτήρας <span class="highlight">␣</span> αντιπροσωπεύει ένα κενό.
                <br>
                Αυτός ο χαρακτήρας <span class="highlight">↩︎</span> αντιπροσωπεύει μια αλλαγή γραμμής. `,
'hb28f1f2ec1744ee9': html`Αυτές οι ιδιότητες δημιουργούνται και συμπληρώνονται από χρήστες για οποιαδήποτε χρήση. Προσθέστε
                    ελέυθερα τις δικές σας. Οι ιδιότητες και οι τιμές που δημιουργείτε
                    <strong>πρέπει να είναι σωστές</strong>. Μπορείτε να εμβαθύνετε
                    <a href="${0}">στη λίστα ιδιοτήτων που χρησιμοποιούνται ήδη απ' τη κοινότητα</a>
                    ή εξερευνήστε τη
                    <a href="${1}">τεκμηρίωση των ιδιοτήτων και τη μηχανή αναζήτησής του</a>.`,
's000a5b76bd3a01c2': `Φόρτωση ιδιοτήτων...`,
's000d98595e959c1e': `Αποκτήστε το στο Google Play`,
's013bdc8cf0d3583d': `Βοηθήστε μας με τα υλικά`,
's01d2865e3e1d5501': `Σας ευχαριστούμε για τη βοήθειά σας!`,
's02ce7a2e7c1b020b': `Επικύρωση καλλιέργειας`,
's03e9c8114521b998': `Θα επεξεργαστώ τα συστατικά`,
's05ec315d9308091a': `Εικονίδιο γωνιών γραμμωτού κώδικα`,
's061eb5af92512c85': `Αποθηκεύτηκε! Μπορείτε να βοηθήσετε με κάποιο άλλο;`,
's06847c221c4c0bc1': `Θα ήθελα να δημιουργήσω μια ιδιότητα για να [περιγράψω την περίπτωση χρήσης σας]...`,
's06f6c6f99db6b552': `Πρωτότυπο`,
's081e2ad82db71e1d': `Ομαδοποιημένες τιμές`,
's09205907b5b56cda': `Όχι`,
's0b4235aae602a950': `ειδική τεκμηρίωση`,
's0bb2d48532acc455': `Λήψη CSV`,
's0d5b7fee0311db68': `Ιδιότητα`,
's0fb218abc2e157ed': `Ακύρωση εικόνας`,
's100c4928cc74642a': `για την υποστήριξη της προόδου της έρευνας για τη δημόσια υγεία.`,
's10db5498186c083b': `Ακύρωση περικοπής`,
's11a18a69b30b65ed': `Βοηθήστε μας να διορθώσουμε σφάλματα στη λίστα συστατικών`,
's1205d5f6fccf8e69': `Αξία Ακινήτου`,
's15d64a0a6715285a': `Νέο κλειδί`,
's166bd56d19670a72': `Ανίπταμαι διαγωνίως`,
's19059bf0c4f7c162': `Περιοχή επιλογής`,
's1a52515ec8ddade8': `Γραμμωτός κώδικας προϊόντος`,
's1c5031113de500ce': `διατηρώντας τη βάση δεδομένων μας ανοιχτή &amp; διαθέσιμη σε όλους,`,
's1dc4daf989c71284': `Βοηθήστε μας να διορθώσουμε τις διατροφικές πληροφορίες`,
's1e00019dc454872d': `Παρακαλώ δώστε ένα όνομα ιδιότητας χρησιμοποιώντας το χαρακτηριστικό property-name.`,
's1e49126af0935a5b': `Λίστα προϊόντων που χρησιμοποιούν αυτήν την ιδιότητα`,
's21e73088de6f26f3': `Λήψη από το App Store`,
's255857544a9d5ec0': `Επαναφορά`,
's25e94495991e95ba': `Ευχαριστoύμε για τη βοήθειά σας! Μπορείτε να βοηθήσετε με κάποια άλλη ερώτηση;`,
's2ceb11be2290bb1b': `Ακύρωση`,
's2db7b654c0a9bde0': `Καταγράψτε το ακίνητο`,
's300b3a6ee4e1252d': str`Κακή αντιστοίχιση ${0}%`,
's33f786bb6b4f0cf4': `Αποτέλεσμα καλλιέργειας`,
's33f85f24c0f5f008': `Αποθήκευση`,
's34be4af4e8fec4ae': `Ρωτήστε πρώτα την κοινότητα`,
's36d86adc823cbfa6': `Πριν δημιουργήσετε μια νέα ιδιοκτησία, συζητήστε την με την κοινότητα:`,
's3781d25aa51a736c': `Τεκμηρίωση Μηχανής Folksonomy`,
's383ae4449428b61e': `Επαναφορά περικοπής`,
's39bcf88721a1e8ee': `Επαναφορά επιλογής`,
's39e14e14300694c7': `Τεκμηρίωση και Οδηγίες`,
's3b430cfa5c1fe7f4': str`Τεκμηρίωση για ${0}`,
's3f4e4b52f230a892': `Καμβάς εικόνας`,
's417b90913e05bc17': `Προεπισκόπηση`,
's41f7dca46d3f1b4a': `Τιμή`,
's422bba9636ce2489': `Κεντρική εικόνα`,
's42dd66b2441566fd': `Κεντρικό εικονίδιο`,
's43df2e8395f6834e': str`Παρακαλούμε δωρίστε στον Έρανό μας για το ${0}`,
's453188ea728f64da': `Προσθέστε ένα θρεπτικό συστατικό`,
's453ab0dbb9b5c777': `Αλλαγή μεγέθους προς τα δεξιά`,
's475b08749d0706ed': `Βοηθήστε μας να ενημερώσουμε εκατομμύρια καταναλωτές σε όλο τον κόσμο για το τι τρώνε`,
's49730f3d5751a433': `Φόρτωση...`,
's4bbc7472834a9686': `Το πρόγραμμα περιήγησής σας δεν υποστηρίζει σάρωση γραμμωτού κώδικα.`,
's4d42cc7e00076a3b': `Αριθμός προϊόντων`,
's4df2f533c0c1e7d0': `Στοιχεία ελέγχου εικόνας`,
's4e94adf723979402': `Το Open Food Facts χρειάζεται τη βοήθειά σας με αυτό το προϊόν.`,
's4f4886341969d552': `Μετακίνηση επιλογής`,
's4f751fb9b3ed766c': `Δημιουργία νέου ακινήτου`,
's547c12ae169d00bc': `Διαθέσιμο στο F-Droid`,
's5560fb119e40923d': `Εισαγάγετε το όνομα της ιδιότητας...`,
's55d7249883a98ca1': `σχετικά με αυτό το ακίνητο στο wiki Open Food Facts`,
's565867d84c04aea2': `Ιδιότητες φίλτρου...`,
's5666afe5cd0166de': `Διορθώστε τα σφάλματα ή τροποποιήστε το κείμενο πριν από την επιβεβαίωση`,
's57472465a23b41db': `Αξίες`,
's58e1eeea7a60ae51': `Φόρτωση προϊόντων...`,
's59df20feee978e5b': `Σφάλμα: Μη έγκυρη τιμή.`,
's5c92c0051d44b6de': `Βοηθήστε μας να διορθώσουμε τις διατροφικές πληροφορίες.`,
's5dd6f12783fca34f': `Επεξεργασία λίστας συστατικών`,
's5e8250fb85d64c23': `Κλείσιμο`,
's5ed03bb1f3a15949': `Εικόνα`,
's6306a31415aea913': `ΣΤΗΡΙΖΩ`,
's6498dfe4855bb3a7': `μονάδα`,
's64ef2a6c2dd1d3d1': `Επεξεργασία`,
's66413c24dcf680e2': `Παράλειψη`,
's67ae6594857a4d57': `Ευχαριστούμε για τη συνεισφορά σας!`,
's6cee7cad81dfedd1': `Περικομμένη εικόνα`,
's6d7b6cdedaadfb6e': `Κάθε δωρεά μετράει! Εκτιμούμε την υποστήριξή σας για την περαιτέρω διαφάνεια των τροφίμων στον κόσμο.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Καλή αντιστοίχιση ${0}%`,
's71a5c9f4b68ef4d4': `Πλήθος`,
's74cb3d66f6a668e1': `Απόδειξη με έγγραφα`,
's787dd11bed0dc88a': `Αλλαγή μεγέθους αριστερά`,
's7ce4fd9430e80cea': `τιμή`,
's801a05fa8e881f37': `Μάθετε περισσότερα σχετικά με τη δημιουργία ακινήτων και τις οδηγίες:`,
's8038273de2cf8b73': `Επιλέξτε μια περιοχή για περικοπή.`,
's839cc2908a5387f2': `Φιλτράρισμα γραμμωτών κωδικών...`,
's86197dcf3e96af64': `Περιηγηθείτε και αναζητήστε υπάρχοντα ακίνητα`,
's8a63be30a129a59c': `Αλλαγή μεγέθους κάτω μέρους`,
's8a8bfd67f2dd2810': `Κατεβάστε την εφαρμογή OFF με αυτόν τον κωδικό QR`,
's8af61807443f32a4': `Δράσεις`,
's8b33c244759d7bd4': `Αλλαγή μεγέθους επάνω δεξιά`,
's8db84aa4bc949af2': `Τεκμηρίωση του Νέου Ακινήτου`,
's8f839a03997a16d7': `Δείτε το προϊόν`,
's901ae1e236ac45d3': `Ακύρωση διαγραφής`,
's907f7a97c6b29425': `Λάβετε υπόψη ότι το μοντέλο δεδομένων ενδέχεται να τροποποιηθεί. Χρησιμοποιήστε το με δική σας ευθύνη.`,
's95d23d03f9147581': `Απομεγέθυνση`,
's976dfd19ef58a1e1': `Κάντε κλικ για να σαρώσετε έναν γραμμωτό κώδικα και να μάθετε τις λεπτομέρειές του (κατάσταση, προτιμήσεις κλπ.)`,
's98ff35f2a00dc60d': `Συστατικά:`,
's9a7f60fce090ecaf': `Αποτυχία φόρτωσης ιδιοτήτων. Δοκιμάστε ξανά αργότερα.`,
's9b87abd68fb9df45': `Δεν βρέθηκε; Δημιουργήστε νέο κλειδί {value}`,
's9c0f52425fd2f07e': `Μπορεί να μην ταιριάζει`,
's9fc41f789c63b40d': `Προϊόντα`,
'sa1fa766e0d5634d7': `Δεν υπάρχει διαθέσιμη βαθμολογία`,
'sa548778b24054030': `Εξερευνήστε όλες τις ιδιότητες που έχουν συνεισφερθεί από το έργο Folksonomy Engine. Αυτές οι ιδιότητες παρέχουν πρόσθετα μεταδεδομένα και πληροφορίες σχετικά με προϊόντα στη βάση δεδομένων Open Food Facts.`,
'sa63907958bd0ec4b': `Αλλαγή μεγέθους επάνω αριστερά`,
'sa95b4224f685a36a': `Κλείσιμο modal`,
'sab56a1d439576fd6': `Εικονίδιο πρότασης`,
'sac47ea2901d04c15': `Αλλαγή μεγέθους κάτω αριστερά`,
'sb125227d436c2925': `Αναζητήστε την ιδέα του ακινήτου σας στην υπάρχουσα βάση δεδομένων ακινήτων:`,
'sb125568d43642e6f': `Απαντήστε σε ερωτήσεις σχετικά με το προϊόν.`,
'sb1c538e038f9b214': str`Πολύ καλή αντιστοίχιση ${0}%`,
'sb28639570ff3b852': `λίστα όλων των ακινήτων`,
'sb3bdd638a58d30f4': `για να εμπλακείτε σε μια κοινότητα αφοσιωμένων πολιτών,`,
'sb3cbcc1bd0fff140': `Μόλις επαληθεύσετε ότι η ιδιότητά σας δεν υπάρχει και η κοινότητα συμφωνήσει ότι είναι χρήσιμη, πρέπει πρώτα να την καταγράψετε στο wiki.`,
'sb3d4f79d9d8b71e5': `Υποβολή`,
'sb560fa37a7bfb6c2': `Δεν βρέθηκαν προϊόντα για αυτό το ακίνητο.`,
'sb7f72e4c8a2d3357': `Φιλτράρισμα τιμών...`,
'sb8178320160f84ea': `Εμφάνιση περικοπής`,
'sbad7d2734149470b': `Επικύρωση`,
'sbb623d6b18d966a0': `Διατροφικά στοιχεία εμφανίζονται στη συσκευασία:`,
'sbd6be5cde472f37c': `Όλες οι πληροφορίες έχουν απαντηθεί! Ευχαριστούμε για τη βοήθειά σας!`,
'sbd9a0b2293b3cd3c': `Μέγεθος μερίδας`,
'sbe472dc3c2685985': `Αντίστοιχη Αξία`,
'sc0520e1732a5c568': `Ανάπτυξη εικόνας`,
'sc0cc559e7ede852a': `Αλλαγή μεγέθους κορυφής`,
'sc1c08d0cbcc3bd24': `Δεν ταιριάζει`,
'sc52696641af72b53': `Εγκαταστήστε την εφαρμογή!`,
'sc5575e3107f87874': `Περιστροφή εικόνας αριστερά`,
'sc57b630a7a70c61f': `Προτεινόμενη διόρθωση`,
'sc681b137e8f604f7': `Επιβεβαίωση διαγραφής`,
'sc6daf8a31883f8b9': `Μετακίνηση εικόνας`,
'sc895972c88d38ca5': `Ιδιότητα Folksonomy`,
'sca0c3305aff570b8': str`ανά καθορισμένη μερίδα "${0}"`,
'scace072bef961918': `Σειρές`,
'scb3b0671d7b7f640': `Νέα τιμή`,
'scb489a1a173ac3f0': `Ναι`,
'scbab4bd737ba7934': str`δωρεά ομαδικής φωτογραφίας ${0}`,
'scd21019c3cd618f3': `Συμμετοχή σε συζήτηση στο Slack`,
'scdb6cad0b92721bf': `Δεν βρέθηκαν ιδιότητες.`,
'scf23a05631f93732': `Επιβεβαίωση διαγραφής`,
'scfed2f270ef6a3aa': `Επιλογή περιοχής`,
'sd1022bc1ef9204f7': `Εικόνα με δυνατότητα ζουμ`,
'sd1077c055cf9ba6b': `Βοηθήστε μας να επικυρώσουμε τη λίστα συστατικών του προϊόντος.`,
'sd698d21ddecba56b': `Γεια! Μπορείτε να μας βοηθήσετε να βελτιώσουμε τις πληροφορίες προϊόντος απαντώντας στα ακόλουθα σημεία:`,
'sd82bc2decefa621b': `για να παραμείνουμε ανεξάρτητοι από τη βιομηχανία τροφίμων,`,
'sdb97e5976482606e': `Ελέγξτε εάν υπάρχει ήδη κάποιο ακίνητο`,
'sdbf806fefc584115': `Θα πρέπει να βρείτε ένα`,
'sdc673e73b5c13aea': `Διαγραφή`,
'sdc792b75f1edcaba': `Βοηθήστε μας να διορθώσουμε την ορθογραφία των συστατικών.`,
'sdca5deead576ceee': `Αλλαγή μεγέθους κάτω δεξιά`,
'sdcc2555c5dde524f': `Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το στοιχείο; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.`,
'se206feec7ec57b28': `ανά 100g`,
'se419a9ab36987490': `Ακυρώ`,
'se5127cf0f92e7e48': `Συμβουλή: Μπορείτε επίσης να βρείτε το`,
'se773f50d2a16d481': `Περιστροφή εικόνας δεξιά`,
'sebb2c6c830a44574': `τεχνική υποδομή (ιστοσελίδα/εφαρμογή για κινητά) &amp; μια μικρή μόνιμη ομάδα`,
'sec6377f3c4e9b28c': `Θα προτείνω μια καλύτερη καλλιέργεια`,
'seea3800e27baa686': `Μεμονωμένα προϊόντα`,
'sefaba4adc4ec9219': `Ιδιότητες Folksonomy`,
'seffa8ca49175b5f0': `Εξατομικευμένες ιδιότητες`,
'sf44a6b3b232c28ea': str`Αντικαταστήστε την τρέχουσα τιμή με ${0}`,
'sf4cd86a2f5ef2588': `Γραμμωτός κώδικας προϊόντος`,
'sf57a61152168cc81': `Βοηθήστε μας να διορθώσουμε την ανίχνευση συστατικών`,
'sf88b90b8ba23871c': `Άγνωστο ταίριασμα`,
'sf9aee319a006c9b4': `Προσθήκη`,
'sfacbbe968fa7d773': `Όνομα ακινήτου:`,
'sfc40ea3d5d5aa6f8': `Οι δωρεές σας χρηματοδοτούν τις καθημερινές λειτουργίες του μη κερδοσκοπικού σωματείου μας:`,
'sfe87465d50530725': `Αντίστοιχη τιμή`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  